<template lang="pug">
.report-root
    general-title(
        title="流量趋势",
        description="提供网站实时的流量数据，通过流量的趋势变化，来分析出网站访客的访问规律、网站发展状况等",
        pos="right",
        :date="timeSpan"
    )
    
    timeSpan(@change="onTimespanChange")
    TopStatis(:data="topStatisData")

    .zone
        TableTitle(icon="fa fa-signal", title="趋势图")
          IndiceCompare(
           @indiceChange="indiceChange",
           :indicesMenu="indicesMenu", 
           :indice="baseIndice", 
           :compIndice="compareIndice")
           

        LineChart(
            :yAxis="yAxis",
            :legend="flowChartLegend",
            :xAxis="flowChartXAxis",
            :series="flowChartSeries",
        )

    .zone
        TableTitle(icon="fa fa-list", title="流量趋势报表")
            div.download-btn(v-show="fluxTableList.length")
                DownloadBtn(
                    reportApi="/api/report/flow",
                    pagetitle="流量趋势报表",
                    :params="downloadParams"
                )
            CustomIndice(:defaults="defaultCustomIndices",
                        :hasSystemIndice="hasSystemIndice",
                        @change="onCustomIndiceChange")
        ComplexTable(:columns="columns",
                      :list="currentPageList",
                      :sum = "{}")
        v-pagination(
            :total="fluxTableList.length",
            :pn="pageNum",
            ps="10",
            @updatepage="onPageChange"
        )
</template>

<script>
/* global _ */
import Vue from 'vue'
import ComplexTable from '../../component/complex-table.vue'
import { getDateString, getDatesByRange, getDateHours } from '../../script/util'
import { INDICE_MAP, INDICE_DEFAULT } from './constants'
import Mixin from '../mixin.js'

const toTimeString = Vue.filter('secToTime')

export default {
  components: {
    ComplexTable
  },
  mixins: [Mixin],
  data () {
    const today = getDateString(new Date())

    return {
      timeSpan: {
        start: this.$store.state.start,
        end: this.$store.state.end
      },
      topStatisRaw: [],
      baseIndice: INDICE_DEFAULT[1][0],
      compareIndice: INDICE_DEFAULT[0][0],
      flowData: [],
      yAxis: [],

      isListLoading: true,
      fluxTableList: [],
      currentPageList: [],
      pageNum: 1,
      hasSystemIndice: true,

      defaultCustomIndices: ['pv', 'uv', 'ipnum', 'newvst', 'atime', 'tnum'],
      tableIndices: ['pv', 'uv', 'ipnum', 'newvst', 'atime', 'tnum']
    }
  },

  computed: {
    columns () {
      let columns = [
        {
          title: '分析维度',
          fixed: true,
          children: [
            {
              title: '日期',
              width: 300,
              key: 'date'
            }
          ]
        }
      ]
      const customColumns = [
        {
          title: '基础流量指标',
          children: [
            {
              title: '浏览量(PV)',
              key: 'pv',
              class: 'right',
              render: this.columnRender
            },
            {
              title: '访客数(UV)',
              key: 'uv',
              class: 'right',
              render: this.columnRender
            },
            {
              title: 'IP',
              key: 'ipnum',
              class: 'right',
              render: this.columnRender
            },
            {
              title: '新独立访客',
              key: 'newvst',
              class: 'right',
              render: this.columnRender
            },
            {
              title: '访问次数',
              key: 'vnum',
              class: 'right',
              render: this.columnRender
            }
          ]
        },
        {
          title: '流量质量指标',
          children: [
            {
              title: '平均访问时长',
              key: 'atime',
              class: 'right',
              render: this.atimeRender
            },
            {
              title: '平均访问页数',
              key: 'anum',
              class: 'right',
              render: this.columnRender
            },
            {
              title: '跳出率',
              class: 'right',
              key: 'jrate',
              render: this.percentRender
            }
          ]
        },
        {
          title: '系统转化指标',
          children: [
            {
              title: '订单量',
              key: 'ordernum',
              class: 'right',
              render: this.columnRender
            },
            {
              title: '订单转化率',
              key: 'orderrate',
              class: 'right',
              render: this.percentRender
            },
            {
              title: '订单金额',
              key: 'orderprice',
              class: 'right',
              render: this.columnRender
            },
            {
              title: '注册量',
              key: 'reg',
              class: 'right',
              render: this.columnRender
            },
            {
              title: '注册转化率',
              key: 'regrate',
              class: 'right',
              render: this.percentRender
            }
          ]
        },
        {
          title: '自定义转化指标',
          children: [
            {
              title: '自定义转化次数',
              key: 'tnum',
              class: 'right',
              render: this.columnRender
            },
            {
              title: '转化率',
              key: 'trate',
              class: 'right',
              render: this.percentRender
            }
          ]
        }
      ]

      const newColumns = _.filter(customColumns, (item) => {
        const newItem = _.filter(item.children, (child) => {
          if (this.tableIndices.includes(child.key)) {
            return child
          }
        })
        item.children = newItem
        if (item.children.length > 0) {
          return item
        }
      })
      columns = _.concat(columns, newColumns)

      return columns
    },

    domainId () {
      return this.$store.state.domainId
    },

    params () {
      if (!this.domainId) {
        return null
      }

      const { start, end } = this.timeSpan
      return {
        domainId: this.domainId,
        cycle: start === end ? 'hour' : 'day',
        start: start,
        end: end
      }
    },

    downloadParams () {
      const { start, end } = this.timeSpan

      return {
        domainId: this.domainId,
        cycle: start === end ? 'hour' : 'day',
        start,
        end
      }
    },

    indicesMenu () {
      const arr = this.tableIndices.map(v => [v, INDICE_MAP[v]])
      let indiceMenu = arr.length ? [['_', '请选择指标'], ...arr] : INDICE_DEFAULT
      indiceMenu = indiceMenu.map(arr => {
        return {
          label: arr[1],
          value: arr[0]
        }
      })
      return indiceMenu
    },

    topStatisData () {
      const obj = this.topStatisRaw
      let indicesMapped = _.concat([], _.cloneDeep(INDICE_DEFAULT))
      indicesMapped = indicesMapped.slice(1).map(k =>
        ({field: k[0], name: k[1]}))
      return indicesMapped.map(({field, name}) => {
        let value = obj[field]
        if (field === 'atime') {
          value = toTimeString(value)
        }
        return { name, value }
      })
    },
    getTypeName () {
      return {
        baseType: this.baseIndice,
        baseName: _.find(this.indicesMenu, {value: this.baseIndice}).label,
        compareType: this.compareIndice !== '_' ? this.compareIndice : '',
        compareName: _.find(this.indicesMenu, {value: this.compareIndice}).label
      }
    },
    flowChartLegend () {
      const {baseType, baseName, compareType, compareName} = this.getTypeName
      const arr = [
        baseType && baseName,
        compareType && compareName
      ].filter(a => Boolean(a))
      return _.uniqWith(arr, _.isEqual)
    },
    flowChartSeries () {
      const {baseType, baseName, compareType, compareName} = this.getTypeName

      let series = [
        {
          name: baseName,
          _type: baseType,
          data: []
        }, {
          name: compareName,
          yAxisIndex: 1,
          _type: compareType,
          data: []
        }
      ].filter(item => Boolean(item._type))
      series = _.uniqWith(series, _.isEqual)

      this.flowData.forEach(item => {
        series.forEach(s => {
          s.data.push(item[s._type])
        })
      })

      return series
    },
    flowChartXAxis () {
      return this.flowData.map(i => i.date)
    },

    tableIndicesMapped () {
      return this.tableIndices.map(key => {
        return {
          field: key,
          name: INDICE_MAP[key]
        }
      })
    }
  },
  watch: {
    params (newVal) {
      if (newVal) {
        this.getFluxSum()
        this.getFluxSegements()
      }
    },
    indicesMenu (newVal) {
      const isSameIndice = (a, b) => a === b.value
      const base = _.find(newVal, i => isSameIndice(this.baseIndice, i))
      const comp = _.find(newVal, i => isSameIndice(this.compareIndice, i))

      this.baseIndice = base ? this.baseIndice : newVal[1].value
      this.compareIndice = comp ? this.compareIndice : newVal[0].value
    }

  },
  mounted () {
    this.getFluxSum()
    this.getFluxSegements()
  },
  methods: {
    indiceChange (obj) {
      this.baseIndice = obj.customIndice
      this.compareIndice = obj.twoIndice
      const yAxis = []
      yAxis.push(this.putyAxisItem(this.baseIndice))
      if (!(this.compareIndice === '_' || this.compareIndice === '')) {
        let newItem = this.putyAxisItem(this.compareIndice)
        newItem.splitLine = {
          show: false
        }
        yAxis.push(newItem)
      }
      this.yAxis = yAxis
    },
    onTimespanChange ({ start, end }) {
      this.timeSpan = { start, end }
    },

    onPageChange (num) {
      num = num || this.pageNum
      const startIndex = (num - 1) * 10
      this.pageNum = num
      this.currentPageList = this.fluxTableList.slice(startIndex, startIndex + 10)
    },

    onCustomIndiceChange (indices) {
      this.tableIndices = indices
    },

    getFluxData (param = {}) {
      if (!this.params) return Promise.resolve({})

      return this.$http.get('/api/report/flow', {
        params: _.extend({}, this.params, param)
      }).then((r) => {
        return r.data || {}
      }).catch(() => {
        return {}
      })
    },

    getFluxSum () {
      this.getFluxData({ issum: 1 }).then(data => {
        if (data.errno === 0) {
          this.topStatisRaw = data.list[0] || {}
        } else {
          data.errmsg && this.$Modal.warn(data.errmsg)
        }
      })
    },

    getFluxSegements () {
      this.isListLoading = true

      const { start, end } = this.timeSpan
      const cycle = start === end ? 'hour' : 'day'

      const emptyItem = {
        domainId: 0,
        pv: 0, // 浏览量
        uv: 0, // 访客数
        ipnum: 0, // ip数
        newvst: 0, // 新独立访客
        jrate: 0, // 跳出率
        atime: 0, // 平均时常
        anum: 0, // 平均访问页数
        vnum: 0, // 访问次数
        tnum: 0, // 转化次数 
        trate: 0, // 转化率
        ordernum: 0,
        orderrate: 0,
        orderprice: 0,
        reg: 0,
        regrate: 0
      }

      this.$store.dispatch('SET_CHART_LOADING', true)
      this.getFluxData({ ps: 9999 }).then(data => {
        let {list} = data
        list = list || []

        const tabelList = _.cloneDeep(list).reverse()
        this.fluxTableList = cycle === 'hour' ? tabelList : tabelList.map(item => {
          item.date = item.date.split(' ')[0]
          return item
        })
        this.onPageChange(1)

        if (cycle === 'day' && list && list.length) {
          const listMap = list.reduce((accu, item) => {
            item.date = item.date.split(' ')[0]
            accu[item.date] = item
            return accu
          }, {})

          list = getDatesByRange({ start, end }).map(date => {
            return listMap[date] || _.extend({ date }, emptyItem)
          })
        } else if (list && list.length) {
          list = getDateHours(start).map(date => {
            return _.find(list, { date }) || _.extend({ date }, emptyItem)
          })
        }
        this.flowData = list
        this.$nextTick(() => {
          this.isListLoading = false
        })

        this.$store.dispatch('SET_CHART_LOADING', false)
      })
    }
  }
}
</script>

<style scoped>
.zone {
    background: #fff;
    margin: 20px 0;
}
.bdb {
    border-bottom: 1px solid #e5e5e5;
}

.multi-indices-menu {
  float: right;
  font-size: 14px;
}
.multi-indices-menu select {
  width: 9em;
  margin: 0 5px;
}
.compare-indice {
  color: #999;
  font-size: 12px;
  margin: 0 5px;
}

.table-title-tip {
    font-size: 12px;
    color: #999;
    margin-left: 5px;
}

.data-table {
    table-layout: fixed;
}

.data-table th:first-child,
.data-table td:first-child {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// flux.vue?4eebc8be